import { render, staticRenderFns } from "./lc-problem-alert.vue?vue&type=template&id=c756ff86&scoped=true&"
import script from "./lc-problem-alert.vue?vue&type=script&lang=js&"
export * from "./lc-problem-alert.vue?vue&type=script&lang=js&"
import style0 from "./lc-problem-alert.vue?vue&type=style&index=0&id=c756ff86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c756ff86",
  null
  
)

export default component.exports